module.exports = __webpack_public_path__ + "img/btnmid.8153bc28.png";